import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import type { ReactElement } from 'react'

import { getCourseFaqItems } from '@/utils/seo'

import { trackEvent } from '@/client/services/analytics'

import SignUpLink from '@/components/Auth/SignUpLink'
import FAQ from '@/components/FAQ/FAQ'

export default function ExploreFooterLoggedOut({
  courseSlug = null,
  hideFaq = false,
}: {
  courseSlug?: string | null
  hideFaq?: boolean
}): ReactElement {
  const router = useRouter()
  const faqItems = getCourseFaqItems(courseSlug)
  return (
    <Flex flexDir="column" textAlign="center" py={14}>
      {faqItems == null || hideFaq ? null : (
        <Box maxWidth="800px" margin="auto" textAlign="left" mb={24}>
          <FAQ items={faqItems} />
        </Box>
      )}
      <Heading as="span" mb={2}>
        Join a Session Today. 100% Free.
      </Heading>
      <Text as="span">
        Join our global community of learners and tutors to get free, quality access to tutoring.
      </Text>
      <Box mt={6}>
        <SignUpLink href={router.asPath}>
          <Button
            variant="accent"
            width="200px"
            onClick={() =>
              trackEvent({
                category: 'Button Click',
                action: 'Explore Sign-Up',
              })
            }
            textDecoration="none"
          >
            Sign Up Now
          </Button>
        </SignUpLink>
      </Box>
    </Flex>
  )
}
